import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=2aad3968"
import script from "./Square.vue?vue&type=script&lang=js"
export * from "./Square.vue?vue&type=script&lang=js"
import style0 from "./Square.vue?vue&type=style&index=0&id=2aad3968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports